<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Puthalath Raghuprasad is a physician practicing in West Texas, USA. He is an artist, painting with oil on canvas. He specializes in painting realistic portraits, animals, birds, flowers, and landscapes. His other interests are poetry, inventing, writing scientific papers on medicine, physics and astronomy. He has been awarded 21 US patents. In medicine, he has published a simple, safe way of resuscitating choking victims and an easy method of purifying basophils (a kind of white cells involved in allergies). In physics, he has published his explanation of what makes the sky blue. In astronomy, in a series of articles, he has elucidated how the fundamental properties of matter, the gravity and axial spin orchestrate all celestial body motion mechanics, in the presence of weightlessness and the friction-free vacuum of the deep space where all bodies are situated. He has constructed two elaborate websites. <em>www.indiancentury.com, www.spinninguniverse.com.</em> Also, his paintings are displayed at: <em>www.epaintings.com.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?aee809a6